import { Link } from '@remix-run/react'
import { Container, Row, Col } from 'reactstrap'

import { type Spotlight } from '#app/models/content.server.ts'

import { SpotlightCard } from './SpotlightCard.tsx'
import { SpotlightsCarousel } from './SpotlightsCarousel.tsx'

export type SpotlightsSectionProps = {
  items: Spotlight[]
  total: number
}

export function SpotlightsSection({
  items,
  total,
}: SpotlightsSectionProps) {
  if (items.length === 0) return null

  const showSeeMore = total > items.length

  return (
    <section className="spotlights-section members-section" id="novidades">
      <div
        className="section-line"
      />
      <div
        style={{
          backgroundColor: '#FFFF',
          padding: '1rem',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Container className="section-two py-4">
          <Row className="align-items-start">
            <Col md="8" className="text-area">
              <h2 className="section-title text-primary fw-bold mb-2">
                Novidades
              </h2>
              <p
                className="text-primary  text-start mb-0"
                style={{ color: '#1D1D1D', fontSize: '16px', fontWeight: '300' }}
              >
                Fique por dentro das últimas novidades do Clube do Tennis.
              </p>
            </Col>
            {showSeeMore ? (
              <Col
                md="4"
                className="d-flex justify-content-md-end align-items-center mt-3 mt-md-0"
              >
                <Link
                  to="/novidades"
                  className="fw-semibold text-primary text-decoration-none"
                >
                  Ver todas
                </Link>
              </Col>
            ) : null}
          </Row>

          {/* Mobile: cards em scroll horizontal */}
          <Row className="mt-4 d-md-none g-0">
            <Col>
              <div
                style={{
                  position: 'relative',
                  marginLeft: '-1rem',
                  marginRight: '-1rem',
                  paddingLeft: '1rem',
                  paddingRight: '1rem',
                }}
              >
                <div
                  className="horizontal-scroll"
                  style={{
                    display: 'flex',
                    overflowX: 'auto',
                    gap: '1rem',
                    scrollSnapType: 'x mandatory',
                    WebkitOverflowScrolling: 'touch',
                    paddingBottom: '0.5rem',
                  }}
                >
                  {items.map((item) => (
                    <div
                      key={item.slug}
                      style={{
                        flex: '0 0 85%',
                        scrollSnapAlign: 'start',
                      }}
                    >
                      <SpotlightCard item={item} />
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>

          {/* Desktop: carrossel */}
          <Row className="mt-4 d-none d-md-block py-1" style={{ overflowX: 'hidden' }}>
            <Col>
              <SpotlightsCarousel items={items} />
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  )
}
